import React from "react";
import useReportPrint from "./useReportPrint";
import Style from "../report.module.scss";

const ReportPrint = ({ data }) => {
  const { availableReports, handlePrintClick, loadingIndex } = useReportPrint({
    data,
  });
  return (
    <div className={`${Style.root} pro-p-5`}>
      {availableReports?.data?.map((value, index) => {
        return (
          value?.status && (
            <div key={index} className={Style.container}>
              <span>{value?.name}</span>
              <button
                onClick={() => handlePrintClick(index, value?.name)}
                className={`pro-btn pro-btn-link pro-ms-3 pro-p-2 ${loadingIndex === index ? "loading" : ""}`}
                disabled={loadingIndex === index}
              >
                {loadingIndex === index ? (
                  <span
                    className={`spinner-border spinner-border-sm ${Style.icon}`}
                    role="status"
                  />
                ) : (
                  <span className={`material-symbols-outlined ${Style.icon}`}>
                    download
                  </span>
                )}
              </button>
            </div>
          )
        );
      })}
    </div>
  );
};

export default ReportPrint;
